import {
    IonCard,
    IonCardContent,
    IonCardHeader,
    IonContent,
    IonPage,
    IonRow,
} from '@ionic/react';
import { Trans } from '@lingui/macro';

import LoginForm from '../components/forms/login/LoginForm';
import Logo from '../components/logo/Logo';
import classes from './Login.module.css';

const Login = () => {
    return (
        <IonPage>
            <IonContent className={classes.LoginContent}>
                <div className="ion-padding ion-margin-top">
                    <IonCard>
                        <IonCardHeader>
                            <IonRow className="ion-justify-content-center">
                                <Logo />
                            </IonRow>
                            <IonRow className="ion-justify-content-center">
                                <h5>
                                    <Trans>Hello! Please login</Trans>
                                </h5>
                            </IonRow>
                        </IonCardHeader>
                        <IonCardContent>
                            <LoginForm />
                        </IonCardContent>
                    </IonCard>
                </div>
            </IonContent>
        </IonPage>
    );
};

export default Login;
